import { useNofollowUrls, useWhiteListDomains } from "contexts/DataContext/hooks";

const useLinkRelValue = (href: string, linktype = "url"): string => {
  const whiteListDomains = useWhiteListDomains();
  const nofollowUrls = useNofollowUrls();

  const isNoffollow = nofollowUrls.some((url) => {
    const urlVal = url.includes("-default") ? url.replace("-default", "") : url;
    return url.endsWith("/") ? href.includes(urlVal.slice(0, -1)) : href.includes(urlVal)
  });

  const isWhitelisted = whiteListDomains.some(({ value: domain }) => href.includes(domain));
  const isInternal = linktype === "story" || href.startsWith("/") || href.startsWith("#");
  const relValue = !isNoffollow && (isWhitelisted || isInternal) ? "noopener noreferrer" : "nofollow";

  return relValue;
};

export default useLinkRelValue;
